// @flow
import React from 'react';
import { token } from '@atlaskit/tokens';
import Flag, { FlagGroup } from '@atlaskit/flag';
import Info from '@atlaskit/icon/core/information-circle';

type Props = {
  isOpen: boolean,
  onDismissed: () => void,
  title: React.Node,
};

const NotificationFlag = (props: Props) =>
  props.isOpen && props.isOpen[0] ? (
    <FlagGroup onDismissed={props.onDismissed}>
      <Flag
        id="1"
        appearance="normal"
        icon={<Info label="Info icon" color={token('color.icon.discovery', '#8270DB')} />}
        title={props.title}
      />
    </FlagGroup>
  ) : null;

export default NotificationFlag;
